import { createModule } from 'terrific-singleton';
import { TerrificSpec } from 'terrific-singleton/terrific-module';
import getCurrentBreakpoint, { onBreakpointChange } from '@project/shared/utils/breakpoints/js/breakpoints';
import * as Track from '@project/shared/utils/tracking/js/tracking';

const classes = {
	leftControl: 'js-m-scrollable-teaser__left-control',
	rightControl: 'js-m-scrollable-teaser__right-control',
	hiddenControl: 'state-m-scrollable-teaser__slider-arrow-hidden',
	scrollWrapper: "js-m-scrollable-teaser__scroll-wrapper",
	headWrapper: "js-m-scrollable-teaser__head",
	contentWrapper: "js-m-scrollable-teaser__content",
	contentScrollWrapper: "js-m-scrollable-teaser__content-scroll",
	listWrapper: "js-m-scrollable-teaser__list",
	teaserItem: "js-m-scrollable-teaser__list-item",
	videoWrapper: "js-m-scrollable-teaser-item__video-area",
	largeTeaser: 'm-scrollable-teaser__list-item--large',
	timelineItem: "js-m-scrollable-teaser__timeline-item",
	timelineItemBar: "m-scrollable-teaser-item__time-bar",
	disabledSilder: 'm-scrollable-teaser--disabled-silder',
	teaserItemGated: 'm-scrollable-teaser-item--gated',
	mainContainer: "js-m-scrollable-teaser__main-scroll-wrapper"
};

@createModule('ScrollableTeaser')
/**
 * scrollable-teaser module implementation.
 */

export class ScrollableTeaser extends TerrificSpec {
	$ctx: JQuery;
	$leftControl: JQuery;
	$rightControl: JQuery;
	$scrollWrapper: JQuery;
	$headWrapper: JQuery;
	$contentWrapper: JQuery;
	$contentScrollWrapper: JQuery;
	$listWrapper: JQuery;
	$teaserItem: JQuery;
	$videoWrapper: JQuery;
	$timelineItem: JQuery;
	$teaserItemGated: JQuery;
	$mainContainer: JQuery;

	start(resolve: Function) {
		this.initVars();
		this.initNavigationArrows();
		this.initScroll();
		this.onScroll();
		this.onVideoTeaserClick();
		if (this.$timelineItem) {
			this.initTimelineTeaser();
		}
		onBreakpointChange(() => {
			this.initNavigationArrows();
			this.onScroll();
			if (this.$timelineItem) {
				this.initTimelineTeaser();
			}
		});
		$(window).resize(() => {
			this.initScroll();
		});

		this.RegisteredUpdate();


		$('.js-o-home-scrollable-teaser__tab-link').on('click', () => {
            this.showHideScroll();
        });


		resolve();
	}

	initVars() {
		this.$ctx = $(this._ctx);
		this.$leftControl = $(`.${classes.leftControl}`, this.$ctx);
		this.$rightControl = $(`.${classes.rightControl}`, this.$ctx);
		this.$scrollWrapper = $(`.${classes.scrollWrapper}`, this.$ctx);
		this.$headWrapper = $(`.${classes.headWrapper}`, this.$ctx);
		this.$contentWrapper = $(`.${classes.contentWrapper}`, this.$ctx);
		this.$contentScrollWrapper = $(`.${classes.contentScrollWrapper}`, this.$ctx);
		this.$listWrapper = $(`.${classes.listWrapper}`, this.$ctx);
		this.$teaserItem = $(`.${classes.teaserItem}`, this.$ctx);
		this.$videoWrapper = $(`.${classes.videoWrapper}`, this.$ctx);
		this.$timelineItem = $(`.${classes.timelineItem}`, this.$ctx);
		this.$teaserItemGated = $(`.${classes.teaserItemGated}`, this.$ctx);
		this.$mainContainer = $(`.${classes.mainContainer}`, this.$ctx).length > 0 ? $(`.${classes.mainContainer}`, this.$ctx) : this.$ctx.closest(`.${classes.mainContainer}`);
	}
	initNavigationArrows() {
		this.$leftControl.on('click', () => {
			this.onLeftControlClick();
		});

		this.$rightControl.on('click', () => {
			this.onRightControlClick()
		});
	}

	initScroll() {
		const viewport = getCurrentBreakpoint() as string;
		if (viewport === 'small') {
			if (this.$listWrapper.width() < this.$contentScrollWrapper.width()) {
				this.$ctx.addClass(classes.disabledSilder);
			} else {
				this.$ctx.removeClass(classes.disabledSilder);
			}
		}
		if (viewport === 'large' || viewport === 'extra-large') {
			if (this.$headWrapper.width() + this.$listWrapper.width() < this.$mainContainer.width()) {
				this.$ctx.addClass(classes.disabledSilder);
			} else {
				this.$ctx.removeClass(classes.disabledSilder);
			}
		}
		this.showHideScroll();
	}
	onVideoTeaserClick() {
		this.$videoWrapper.on('click', (ev: any) => {
			$(ev.currentTarget).parents(`.${classes.teaserItem}`).addClass(classes.largeTeaser);
			$(ev.currentTarget).closest('li').siblings().removeClass(classes.largeTeaser);

			var itemWidth = 365;
			var headWidth = this.$headWrapper.width();
			var videoLeft = $(ev.currentTarget).closest('li').index() * itemWidth + headWidth;
			var videoCurrentLeft = videoLeft + 641 - this.$scrollWrapper.width();
			var currentScrollLeft = this.$scrollWrapper.scrollLeft();
			const viewport = getCurrentBreakpoint() as string;
			if (!$(ev.currentTarget).hasClass(classes.largeTeaser) || viewport === 'medium' || viewport === 'large' || viewport === 'extra-large') {
				if (currentScrollLeft < videoCurrentLeft) {
					this.$scrollWrapper.animate(
						{
							scrollLeft: videoCurrentLeft,
						},
						250
					);
				}
			}
			if ($('video').length > 1) {
				$('html').find(`.${classes.videoWrapper}`).not($(ev.currentTarget)).find('video').trigger('pause');
			}
		});
	}

	initTimelineTeaser() {
		const viewport = getCurrentBreakpoint() as string;
		var maxLength = this.$timelineItem.last().data('step-index');
		var mobileItemWidth = $(window).width() * 0.768 + 20;

		for (var i = 0; i < maxLength + 1; i++) {
			var teaserLength = $($(this.$timelineItem).parent()).find('[data-step-index="' + i + '"]').length;
			if (i == maxLength) {
				$($($(this.$timelineItem).parent()).find('[data-step-index="' + i + '"]')).find(`.${classes.timelineItemBar}`).hide();
			} else {
				if (viewport === 'small' || viewport === 'medium') {
					$($($(this.$timelineItem).parent()).find('[data-step-index="' + i + '"]')).find(`.${classes.timelineItemBar}`).width(teaserLength * mobileItemWidth)
				} else {
					$($($(this.$timelineItem).parent()).find('[data-step-index="' + i + '"]')).find(`.${classes.timelineItemBar}`).width(teaserLength * 365)
				}
			}
		}
	}

	/**
	 * method click left arrow
	 */
	onLeftControlClick() {
		this.$rightControl.parent().removeClass(classes.hiddenControl)
		this.teaserScrollLeft();
	}

	teaserScrollLeft() {
		var currentScrollLeft = this.$scrollWrapper.scrollLeft();
		var contentCurrentScrollLeft = this.$contentScrollWrapper.scrollLeft();
		var mobileItemWidth = $(window).width() * 0.768 + 20;
		const viewport = getCurrentBreakpoint() as string;

		if (viewport === 'small' || viewport === 'medium') {
			this.$contentScrollWrapper.animate(
				{
					scrollLeft: contentCurrentScrollLeft - mobileItemWidth,
				},
				150
			);
			if (contentCurrentScrollLeft <= mobileItemWidth) {
				this.$leftControl.parent().addClass(classes.hiddenControl)
			}
		} else {
			this.$scrollWrapper.animate(
				{
					scrollLeft: currentScrollLeft - 365,
				},
				150
			);
			if (currentScrollLeft <= 365) {
				this.$leftControl.parent().addClass(classes.hiddenControl)
			}
		}
	}
	/**
	 * method click right arrow
	 */
	onRightControlClick() {
		this.$leftControl.parent().removeClass(classes.hiddenControl)
		this.teaserScrollRight();
	}

	teaserScrollRight() {
		var currentScrollLeft = this.$scrollWrapper.scrollLeft();
		var contentCurrentScrollLeft = this.$contentScrollWrapper.scrollLeft();
		var mobileItemWidth = $(window).width() * 0.768 + 20;
		var maxScrollArea = this.$headWrapper.width() + this.$contentWrapper.width() - this.$scrollWrapper.width();
		var maxContentScrollArea = this.$listWrapper.width() - this.$contentScrollWrapper.width();
		const viewport = getCurrentBreakpoint() as string;

		if (viewport === 'small' || viewport === 'medium') {
			this.$contentScrollWrapper.animate(
				{
					scrollLeft: contentCurrentScrollLeft + mobileItemWidth,
				},
				150
			);
			if (contentCurrentScrollLeft + mobileItemWidth > maxContentScrollArea - 1) {
				this.$rightControl.parent().addClass(classes.hiddenControl)
			}
		} else {
			this.$scrollWrapper.animate(
				{
					scrollLeft: currentScrollLeft + 365,
				},
				150
			);
			if (currentScrollLeft + 365 > maxScrollArea - 1) {
				this.$rightControl.parent().addClass(classes.hiddenControl)
			}
		}
	}

	onScroll() {
		const viewport = getCurrentBreakpoint() as string;
		this.$contentScrollWrapper.on('scroll', () => {
			var contentCurrentScrollLeft = this.$contentScrollWrapper.scrollLeft();
			var maxContentScrollArea = this.$listWrapper.width() - this.$contentScrollWrapper.width();
			if (viewport === 'small' || viewport === 'medium') {
				if (contentCurrentScrollLeft > 0) {
					this.$leftControl.parent().removeClass(classes.hiddenControl)
				} else if (contentCurrentScrollLeft == 0) {
					this.$leftControl.parent().addClass(classes.hiddenControl)
				}
				if (contentCurrentScrollLeft > maxContentScrollArea - 1) {
					this.$rightControl.parent().addClass(classes.hiddenControl)
				} else if (contentCurrentScrollLeft < maxContentScrollArea - 1) {
					this.$rightControl.parent().removeClass(classes.hiddenControl)
				}
			}
		});
		this.$scrollWrapper.on('scroll', () => {
			var currentScrollLeft = this.$scrollWrapper.scrollLeft();
			var maxScrollArea = this.$headWrapper.width() + this.$contentWrapper.width() - this.$scrollWrapper.width();
			if (currentScrollLeft > 0) {
				this.$leftControl.parent().removeClass(classes.hiddenControl)
			} else if (currentScrollLeft == 0) {
				this.$leftControl.parent().addClass(classes.hiddenControl)
			}
			if (currentScrollLeft > maxScrollArea - 1) {
				this.$rightControl.parent().addClass(classes.hiddenControl)
			} else if (currentScrollLeft < maxScrollArea - 1) {
				this.$rightControl.parent().removeClass(classes.hiddenControl)
			}
		});
	}

	RegisteredUpdate() {
		if (Track.isKnownMarketoLead()) {
			this.$teaserItemGated.removeClass('m-scrollable-teaser-item--locked');
		}

		if (Track.isKnownCdcLead()) {
			this.$teaserItemGated.removeClass('m-scrollable-teaser-item--locked');
		}
	}

	showHideScroll() {
		const viewportSize = getCurrentBreakpoint() as string;
		if (viewportSize === 'large' || viewportSize === 'extra-large') {
			$('.js-m-scrollable-teaser__list').each(function() {
				let parent = $(this).closest('.js-o-home-scrollable-teaser__content-item');
				const containerWidth = $(this).width();
				const scrollWidth = $('.js-m-scrollable-teaser__content-scroll').width();

				const itemWidth = $(this).children().first().outerWidth(true);

				const itemsVisible = Math.floor(containerWidth / itemWidth);

				if (itemsVisible <= 2) {
					parent.addClass('m-scrollable-teaser--disabled-silder');
				} else {
					parent.removeClass('m-scrollable-teaser--disabled-silder');
				}
			});
		}
	}

	stop() { }
}
